import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export { StyledContainer };
